// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__U8_71","auraAppText":"styles_auraAppText__BafgT"};